export enum PlatformEnum {
    IOS = 'ios',
    ANDROID = 'android',
    WEB = 'web'
}